import type { Account } from '@/modules/account'

// The ad click id and utm tags saved at sign-up ride along, so Meta can tie the case to its ad.
// Account id and email come last so a stray sign-up tag can never replace them.
export const toTrialCaseNamedProps = (
  account: Account,
  email: string | undefined,
) => ({
  ...account.trialSource,
  account_id: account.id,
  email,
})
